import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationTenriPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationTenri,
);
